import React from 'react';
import {useIntl} from 'react-intl';
import {InputLabel} from 'web-components';
import {PreviewSelector} from './PreviewSelector.styled';
import {createFragmentContainer, graphql} from 'react-relay';
import {SkillsSelections} from './SkillsSelections';
import SkillDropdown from '../skill-dropdown/SkillDropdown';

const SkillsPreviewSelector = ({
	skills,
	skillCategories,
	selectedSkills,
	onChange,
	warningCallback = () => false,
	selectionHeaderLabel,
	hideSelectionHeaderActions = false,
}) => {
	const {formatMessage} = useIntl();

	if (!selectionHeaderLabel) {
		selectionHeaderLabel = formatMessage({id: `common.selected`});
	}

	const onSkillSelectionUpdate = (_, skillIds) => {
		onChange(skillIds);
	};

	const onRemove = skill => {
		onChange(selectedSkills.filter(item => item !== skill.id));
	};

	return (
		<PreviewSelector>
			<InputLabel
				text={formatMessage({id: 'common.skills'})}
				child={
					<SkillDropdown
						usePortal
						name={formatMessage({id: 'settings_skills.add_skills'})}
						skills={skills}
						skillCategories={skillCategories}
						selectedItems={selectedSkills}
						onSelect={onSkillSelectionUpdate}
						onRemove={onSkillSelectionUpdate}
						selectedGroupName={null}
					/>
				}
			/>
			<SkillsSelections
				header={`${selectionHeaderLabel} (${selectedSkills.length})`}
				skills={skills}
				selectedSkills={selectedSkills}
				onRemove={onRemove}
				warningCallback={warningCallback}
				hideSelectionHeaderActions={hideSelectionHeaderActions}
			/>
		</PreviewSelector>
	);
};
export default createFragmentContainer(SkillsPreviewSelector, {
	skillCategories: graphql`
        fragment SkillsPreviewSelector_skillCategories on SkillCategory @relay(plural: true) {
            ...SkillDropdown_skillCategories
        }
	`,
	skills: graphql`
        fragment SkillsPreviewSelector_skills on Skill @relay(plural: true) {
            ...SkillDropdown_skills
            id
            name
            category {
                id
                name
            }
        }
	`,
});
